import { render, staticRenderFns } from "./DonatesPage.vue?vue&type=template&id=30902478&scoped=true&"
import script from "./DonatesPage.vue?vue&type=script&lang=js&"
export * from "./DonatesPage.vue?vue&type=script&lang=js&"
import style0 from "./DonatesPage.vue?vue&type=style&index=0&id=30902478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30902478",
  null
  
)

export default component.exports